var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popover',{attrs:{"manual":true,"target":_vm.target,"primaryButton":_vm.primaryButton,"secondaryButton":_vm.secondaryButton,"title":_vm.$tc('title')},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(
      _vm.$t('message', {
        item1: _vm.useEscapeHtml(_vm.entityName),
        item2: _vm.useEscapeHtml(_vm.vatAssociate),
      })
    )}})])}
var staticRenderFns = []

export { render, staticRenderFns }